import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { tenantKey } from '@/lib/queryClient'
import { useTenant } from '@/hooks/useTenant'
import { yearEndCloseApi } from './api'

export function useFiscalYears() {
  const tenantId = useTenant()
  return useQuery({
    queryKey: tenantKey(tenantId, 'fiscal-years'),
    queryFn: yearEndCloseApi.fiscalYears,
  })
}

export function usePreviewClose() {
  return useMutation({
    mutationFn: ({ year, fiscalStartMonth }: { year: number; fiscalStartMonth: number }) =>
      yearEndCloseApi.preview(year, fiscalStartMonth),
  })
}

function invalidate(qc: ReturnType<typeof useQueryClient>, tenantId: string | null) {
  qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'fiscal-years') })
}

export function useRunClose() {
  const qc = useQueryClient()
  const tenantId = useTenant()
  return useMutation({
    mutationFn: ({
      fiscalYear,
      fiscalStartMonth,
    }: {
      fiscalYear: number
      fiscalStartMonth: number
    }) => yearEndCloseApi.close(fiscalYear, fiscalStartMonth),
    onSuccess: () => invalidate(qc, tenantId),
  })
}

export function useReverseClose() {
  const qc = useQueryClient()
  const tenantId = useTenant()
  return useMutation({
    mutationFn: ({ year, fiscalStartMonth }: { year: number; fiscalStartMonth: number }) =>
      yearEndCloseApi.reverse(year, fiscalStartMonth),
    onSuccess: () => invalidate(qc, tenantId),
  })
}
